import React from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

import useMediaColorByFormat from "@/src/hooks/useMediaColorByFormat";

import { getTranslatedMetadata } from "../../../utils/data/Content";
import Tag, { SIZES_TAG } from "../../tag/Tag";

import type { JSX } from "react";

import type { MediaFormat } from "../../../constants/media";
import type { AppState } from "../../../reducers";
import type { KeyWithTranslation } from "../../../types";

interface AdbreasAcceptedFormatTags {
  acceptedMediaFormatList: KeyWithTranslation<MediaFormat>[];
}

export default function AdbreaksAcceptedFormatTags({
  acceptedMediaFormatList,
}: AdbreasAcceptedFormatTags): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");

  const languageId = useSelector(
    (reduxState: AppState) => reduxState.languages.current.uuid,
  );

  const getMediaColor = useMediaColorByFormat();

  const list = acceptedMediaFormatList?.reduce(
    (acc: JSX.Element[], currentFormat, index) => {
      const color = getMediaColor(currentFormat.key);
      const isLast = index === acceptedMediaFormatList.length - 1;

      const translatedType = getTranslatedMetadata(
        currentFormat,
        "title",
        languageId,
      ) as string;

      acc.push(
        <Tag
          key={`${currentFormat.key}-${uuidv4()}`}
          color={color}
          size={SIZES_TAG.SMALL}
        >
          {translatedType}
        </Tag>,
      );

      if (!isLast) {
        acc.push(<span> {t("dropzonePlaceholderSeparator")} </span>);
      }

      return acc;
    },
    [],
  );

  return (
    <div className="m-auto flex items-center gap-[0.3125rem] font-semibold">
      {t("dropzonePlaceholderDrop")}
      {list}
      {t("dropzonePlaceholderInThisSection")}
    </div>
  );
}
